module.exports = __webpack_public_path__ + "static/media/okwash.fdf7e687.png";